<template>
  <component
    :is="linkComponent"
    class="logo-container"
    v-bind="linkProps"
  >
    <build-version>
      <img
        :src="path"
        class="logo"
        :title="`${siteName} Logo`"
      >
    </build-version>
  </component>
</template>

<script>
import pageElementLogoMixin from '../mixins/page-element-logo'

export default {
  name: 'page-ement-logo',
  mixins: [pageElementLogoMixin],
  computed: {
    siteName() {
      return this.$store.state.registry.getSiteSetting('title')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";
.logo {
  width: var(--main-logo-width);
  @include media-breakpoint-up(sm) {
    width: var(--main-logo-width-sm);
  }
  @include media-breakpoint-up(md) {
    width: var(--main-logo-width-md);
  }
  @include media-breakpoint-up(lg) {
    width: var(--main-logo-width-lg);
  }
}
</style>
